import { gql } from "@apollo/client";
import { AddressInfoFragment } from "graphql/Address/fragments";

export const DriverInfoFragment = gql`
fragment DriverInfo on Driver {
  _id
  driver_UID
  driver_firstname
  driver_lastname
  driver_email
  driver_phone_number
  driver_username
  driver_password
  driver_address {
    ...AddressInfo
  }
  driver_profile_picture
  driver_id_card
  driver_id_card_type
  driver_license
  driver_criminal_record
  driver_proof_of_address
  driver_emergency_contact_firstname
  driver_emergency_contact_lastname
  driver_emergency_contact_phone_number
  driver_is_paid_by_paps
  driver_contract_end
  driver_contract_start
  driver_is_trained
  driver_is_available
  driver_created_at
  driver_updated_at
  driver_is_deleted
}
${AddressInfoFragment}
`;

export const ConveyorInfoFragment = gql`
  fragment ConveyorInfo on Conveyor {
    _id
    conveyor_UID
    conveyor_firstname
    conveyor_lastname
    conveyor_email
    conveyor_phone_number
    conveyor_username
    conveyor_password
    conveyor_address {
      ...AddressInfo
    }
    conveyor_profile_picture
    conveyor_id_card
    conveyor_id_card_type
    conveyor_criminal_record
    conveyor_proof_of_address
    conveyor_emergency_contact_firstname
    conveyor_emergency_contact_lastname
    conveyor_emergency_contact_phone_number
    conveyor_contract_end
    conveyor_contract_start
    conveyor_is_trained
  }
  ${AddressInfoFragment}
`;
